import type { enBoApprovals } from '../en/bo-approvals';

export const idBoApprovals: Record<keyof typeof enBoApprovals, string> = {
  // Kotak masuk dan riwayat
  'bo.approvals.title': 'Persetujuan',
  'bo.approvals.subtitle': 'Keputusan yang menunggu Anda di {branch}, beserta riwayatnya.',
  'bo.approvals.tabs': 'Tampilan persetujuan',
  'bo.approvals.tab.inbox': 'Kotak masuk',
  'bo.approvals.tab.history': 'Riwayat',
  'bo.approvals.myDelegations': 'Delegasi saya',
  'bo.approvals.refreshing': 'Memperbarui…',
  'bo.approvals.unknownUser': 'Tidak diketahui',
  'bo.approvals.byAt': '{name} · {time}',
  'bo.approvals.inboxTitle': 'Menunggu keputusan Anda',
  'bo.approvals.inboxDesc': 'Yang bisa Anda putuskan sekarang di cabang ini, terlama di atas.',
  'bo.approvals.inboxEmpty':
    'Tidak ada yang menunggu Anda. Permintaan pembelian, pesanan pembelian, catatan waste, dan stok opname muncul di sini saat sebuah langkah butuh keputusan Anda.',
  'bo.approvals.inStok': 'Diputuskan di Stok',
  'bo.approvals.col.type': 'Jenis',
  'bo.approvals.col.document': 'Dokumen',
  'bo.approvals.col.step': 'Langkah',
  'bo.approvals.col.submitted': 'Diajukan',
  'bo.approvals.col.submittedBy': 'Diajukan oleh',
  'bo.approvals.col.status': 'Status',
  'bo.approvals.col.decided': 'Diputuskan',
  'bo.approvals.historyTitle': 'Permintaan yang sudah diputuskan',
  'bo.approvals.historyDesc': 'Permintaan persetujuan terbaru di cabang ini, terbaru di atas.',
  'bo.approvals.historyFilter': 'Saring menurut status',
  'bo.approvals.filter.decided': 'Semua keputusan',
  'bo.approvals.historyEmpty':
    'Belum ada permintaan yang diputuskan. Permintaan yang disetujui, ditolak, dan dibatalkan muncul di sini.',
  'bo.approvals.historyEmptyFiltered': 'Belum ada permintaan dengan status ini.',
  // Detail
  'bo.approvals.drawer.title': 'Permintaan persetujuan',
  'bo.approvals.drawer.status': 'Status',
  'bo.approvals.drawer.policy': 'Kebijakan',
  'bo.approvals.drawer.policyValue': '{name} · versi {version}',
  'bo.approvals.drawer.submitted': 'Diajukan',
  'bo.approvals.drawer.decided': 'Diputuskan',
  'bo.approvals.drawer.openDocument': 'Buka dokumen',
  'bo.approvals.drawer.readOnly':
    'Permintaan ini sudah diputuskan; langkah-langkahnya disimpan sebagai catatan dan tidak dapat diubah.',
  // Eskalasi
  'bo.approvals.escalate.title': 'Eskalasi',
  'bo.approvals.escalate.desc':
    'Alihkan langkah saat ini ({step}) ke orang lain, misalnya saat penyetuju sedang tidak ada. Setelah itu hanya orang tersebut yang dapat memutuskannya.',
  'bo.approvals.escalate.open': 'Eskalasi…',
  'bo.approvals.escalate.to': 'Alihkan ke',
  'bo.approvals.escalate.toHint':
    'Hanya orang yang berwenang memutuskan langkah ini yang ditampilkan — bukan pengaju atau orang yang sudah menyetujui.',
  'bo.approvals.escalate.choose': 'Pilih penyetuju',
  'bo.approvals.escalate.toRequired': 'Pilih siapa yang memutuskan langkah ini.',
  'bo.approvals.escalate.reason': 'Alasan',
  'bo.approvals.escalate.reasonHint': 'Tampil pada langkah, misalnya “Manajer sedang cuti”.',
  'bo.approvals.escalate.reasonShort': 'Tulis alasan minimal 3 karakter.',
  'bo.approvals.escalate.submit': 'Eskalasi',
  'bo.approvals.escalate.submitting': 'Mengeskalasi…',
  'bo.approvals.escalate.done': 'Langkah dialihkan ke {name}.',
  'bo.approvals.escalate.noStaff':
    'Tidak ada orang lain di cabang ini yang berwenang memutuskan langkah ini. Berikan izinnya kepada seseorang terlebih dahulu.',

  // Kebijakan
  'bo.policies.title': 'Kebijakan persetujuan',
  'bo.policies.subtitle':
    'Siapa yang harus menyetujui apa, menurut jenis dokumen, cabang, dan jumlah.',
  'bo.policies.tabs': 'Pengaturan persetujuan',
  'bo.policies.tab.policies': 'Kebijakan',
  'bo.policies.tab.delegations': 'Delegasi',
  'bo.policies.add': 'Tambah kebijakan',
  'bo.policies.readOnly':
    'Hanya pengguna yang boleh mengelola persetujuan yang dapat melihat dan mengubah kebijakan.',
  'bo.policies.noAccess':
    'Kebijakan menentukan siapa yang menyetujui permintaan pembelian, pesanan, faktur pemasok, dan pembayaran. Minta manajer dengan hak persetujuan untuk mengubahnya.',
  'bo.policies.howChosen':
    'Pengajuan memakai kebijakan aktif sesuai jenisnya yang rentang jumlahnya mencakup jumlah tersebut. Kebijakan cabang mengalahkan kebijakan semua cabang. Tanpa kebijakan yang cocok, berlaku satu langkah bawaan (pembelian, persetujuan keuangan, atau verifikasi pembayaran) — tidak pernah disetujui otomatis.',
  'bo.policies.empty':
    'Belum ada kebijakan, sehingga dokumen langsung disetujui saat diajukan. Tambahkan kebijakan per jenis dokumen dan rentang jumlah.',
  'bo.policies.domainEmpty':
    'Belum ada kebijakan untuk jenis ini: pengajuan mendapat satu langkah persetujuan bawaan.',
  'bo.policies.domainCount': 'Kebijakan: {count}',
  'bo.policies.col.name': 'Nama',
  'bo.policies.col.branch': 'Cabang',
  'bo.policies.col.band': 'Rentang jumlah',
  'bo.policies.steps': 'Langkah',
  'bo.policies.version': 'Versi {version}',
  'bo.policies.allBranches': 'Semua cabang',
  'bo.policies.otherBranch': 'Cabang lain',
  'bo.policies.band.atLeast': 'Mulai',
  'bo.policies.band.below': 'di bawah',
  'bo.policies.editNamed': 'Ubah {name}',
  'bo.policies.createTitle': 'Kebijakan persetujuan baru',
  'bo.policies.editTitle': 'Ubah kebijakan persetujuan',
  'bo.policies.formDesc': 'Langkah diputuskan berurutan, masing-masing oleh orang yang berbeda.',
  'bo.policies.snapshotNote':
    'Perubahan hanya berlaku untuk pengajuan baru. Permintaan yang sedang menunggu tetap memakai langkah saat diajukan.',
  'bo.policies.domain': 'Jenis dokumen',
  'bo.policies.domainHint': 'Tidak dapat diubah setelah kebijakan dibuat.',
  'bo.policies.nameHint': 'Misalnya “Pembelian di atas 5 juta”.',
  'bo.policies.branchHint': 'Semua cabang, atau hanya satu cabang (kebijakan cabang diutamakan).',
  'bo.policies.min': 'Mulai jumlah ({currency})',
  'bo.policies.minHint': 'Termasuk.',
  'bo.policies.max': 'Di bawah jumlah ({currency})',
  'bo.policies.maxHint': 'Tidak termasuk.',
  'bo.policies.maxHintOpen': 'Kosong = tanpa batas atas.',
  'bo.policies.amountInvalid': 'Masukkan jumlah bulat (hanya angka).',
  'bo.policies.maxAboveMin': 'Batas atas harus lebih besar dari batas bawah.',
  'bo.policies.stepsHint':
    '1 sampai {max} langkah, diputuskan sesuai urutan ini. Tidak ada yang boleh menyetujui dua langkah pada satu permintaan.',
  'bo.policies.stepsCount': 'Kebijakan butuh 1 sampai {max} langkah.',
  'bo.policies.step.n': 'Langkah {n}',
  'bo.policies.step.label': 'Label',
  'bo.policies.step.labelPlaceholder': 'mis. Pemeriksaan manajer',
  'bo.policies.step.labelRequired': 'Beri label untuk langkah ini.',
  'bo.policies.step.permission': 'Izin yang dibutuhkan',
  'bo.policies.step.permissionRequired': 'Pilih izin.',
  'bo.policies.step.role': 'Peran',
  'bo.policies.step.anyRole': 'Peran apa saja',
  'bo.policies.step.up': 'Naikkan langkah {n}',
  'bo.policies.step.down': 'Turunkan langkah {n}',
  'bo.policies.step.remove': 'Hapus langkah {n}',
  'bo.policies.step.add': 'Tambah langkah',
  'bo.policies.activeLabel': 'Aktif',
  'bo.policies.activeHint': 'Kebijakan nonaktif dilewati untuk pengajuan baru.',
  'bo.policies.saved': 'Kebijakan “{name}” disimpan.',

  // Delegasi
  'bo.delegations.title': 'Delegasi persetujuan',
  'bo.delegations.subtitle':
    'Izinkan rekan memutuskan langkah persetujuan Anda selama Anda tidak ada. Mereka memutuskan atas nama Anda, dan catatannya menampilkan kedua nama.',
  'bo.delegations.add': 'Delegasikan',
  'bo.delegations.mineTitle': 'Delegasi saya',
  'bo.delegations.mineDesc': 'Delegasi yang Anda berikan atau terima.',
  'bo.delegations.allTitle': 'Semua delegasi',
  'bo.delegations.allDesc':
    'Anda melihat delegasi semua orang karena boleh mengelola persetujuan; Anda dapat mencabut yang mana pun.',
  'bo.delegations.empty':
    'Belum ada delegasi. Delegasikan sebelum cuti agar permintaan tidak tertahan.',
  'bo.delegations.you': 'Anda',
  'bo.delegations.col.delegator': 'Pemberi',
  'bo.delegations.delegate': 'Penerima delegasi',
  'bo.delegations.col.branch': 'Cabang',
  'bo.delegations.col.period': 'Berlaku',
  'bo.delegations.col.status': 'Status',
  'bo.delegations.reason': 'Alasan',
  'bo.delegations.fromAt': 'dari {time}',
  'bo.delegations.toAt': 'sampai {time}',
  'bo.delegations.state.active': 'Aktif',
  'bo.delegations.state.scheduled': 'Terjadwal',
  'bo.delegations.state.expired': 'Kedaluwarsa',
  'bo.delegations.state.revoked': 'Dicabut',
  'bo.delegations.revoke': 'Cabut',
  'bo.delegations.revokeNamed': 'Cabut delegasi ke {name}',
  'bo.delegations.revokeTitle': 'Cabut delegasi?',
  'bo.delegations.revokeBody':
    '{name} tidak lagi dapat memutuskan atas dasar delegasi ini. Keputusan yang sudah dibuat tetap berlaku.',
  'bo.delegations.revoking': 'Mencabut…',
  'bo.delegations.revoked': 'Delegasi dicabut.',
  'bo.delegations.createTitle': 'Delegasikan persetujuan saya',
  'bo.delegations.formDesc':
    'Penerima dapat memutuskan langkah yang bisa Anda putuskan, hanya dalam periode ini.',
  'bo.delegations.delegateHint': 'Anggota tim aktif selain Anda.',
  'bo.delegations.choose': 'Pilih rekan kerja',
  'bo.delegations.delegateRequired': 'Pilih siapa yang memutuskan untuk Anda.',
  'bo.delegations.branchHint': 'Semua cabang Anda, atau hanya satu.',
  'bo.delegations.from': 'Berlaku dari',
  'bo.delegations.to': 'Berlaku sampai',
  'bo.delegations.timeZoneHint': 'Waktu cabang ({zone}).',
  'bo.delegations.timeRequired': 'Masukkan tanggal dan jam.',
  'bo.delegations.timeInvalid': 'Masukkan tanggal dan jam yang valid.',
  'bo.delegations.toAfterFrom': 'Waktu berakhir harus setelah waktu mulai.',
  'bo.delegations.reasonHint': 'Misalnya “Cuti tahunan”.',
  'bo.delegations.reasonShort': 'Tulis alasan minimal 3 karakter.',
  'bo.delegations.submit': 'Delegasikan',
  'bo.delegations.created': 'Delegasi disimpan.',
  'bo.delegations.noStaff': 'Tidak ada anggota tim aktif lain untuk menerima delegasi.',
};
